<div class="table-wrapper">
  <div class="table-container">
    <table class="crud-table">
      <thead>
        <tr>
          <th>{{ "CRUD.DISTRICT.DISTRICT_NAME" | translate}}</th>
          <th>{{ "CRUD.DISTRICT.DISTRICT_CODE" | translate}}</th>
          <th>{{ "CRUD.DISTRICT.REGION" | translate}}</th>
          <th>{{ "CRUD.DISTRICT.DISTRICT_NUMBER" | translate}}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let area of areas"
          data-bs-toggle="modal"
          data-bs-target="#editAddModal"
          (click)="selectArea(area)"
        >
          <td>{{ area.name | hasValue }}</td>
          <td>{{ area.code | hasValue }}</td>
          <td>{{ area.region.name | hasValue }}</td>
          <td>{{ area.number | hasValue }}</td>
          <td>
            <svg
              width="15"
              data-bs-toggle="modal"
              data-bs-target="#deleteDistrict"
              height="15"
              (click)="$event.stopPropagation(); onDeleteArea(area)"
              viewBox="0 0 22 22"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM6 11C6 10.4477 6.44772 10 7 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H7C6.44772 12 6 11.5523 6 11Z"
                fill="#17171A"
              />
            </svg>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pagination">
      <app-asset-list-pagination
        [pageFromList]="currentPage"
        (pageChanged)="onPageChange($event)"
        [totalItems]="count"
      >
      </app-asset-list-pagination>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="editAddModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content edit-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header edit-modal-header">
        <h5 class="modal-title" id="districtModalTitle">
          {{ (isEditMode ? ('COMMON.EDIT' | translate) + ' ' + ('COMMON.UT.SINGLE' | translate) : ('CRUD_SETTINGS.ADD_NEW' | translate) + ' ' + ('COMMON.UT.SINGLE' | translate)) }}
        </h5>
      </div>
      <div class="modal-body edit-modal-body">
        <div>
          <span>{{ "CRUD.NAME" | translate}}</span>
          <label for="nameInput">
            <input id="nameInput" type="text" [(ngModel)]="updatedName" />
          </label>
        </div>
        <div class="edit-field">
          <span>{{ "CRUD.CODE" | translate}}</span>
          <label for="codeInput">
            <input id="codeInput" type="text" [(ngModel)]="updatedCode" />
          </label>
        </div>
        <div class="edit-field">
          <span>{{ "CRUD.NUMBER" | translate}}</span>
          <label for="numberInput">
            <input id="numberInput" type="text" [(ngModel)]="updatedNumber" />
          </label>
        </div>
        <span>{{ "CRUD.DISTRICT.REGION" | translate}}</span>
        <select [(ngModel)]="updatedRegionId">
          <option [value]="null" disabled hidden>{{ "CRUD.DISTRICT.SELECT_REGION" | translate}}</option>
          <option *ngFor="let region of regions" [value]="region.id">
            {{ region.name | hasValue}}
          </option>
        </select>
      </div>
      <div class="modal-footer edit-modal-footer">
        <div>
          <button class="cancel" data-bs-dismiss="modal" #closeEditModal>{{ "CRUD.CANCEL" | translate}}</button>
        </div>
        <div>
          <button class="save" (click)="save()">
            {{ "CRUD.SAVE" | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="deleteDistrict"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content delete-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header delete-modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ "CRUD_SETTINGS.ARE_YOU_SURE_DELETE" | translate }}
          {{ "COMMON.UT.SINGLE" | translate }}?
        </h5>
      </div>
      <div class="modal-footer delete-modal-footer">
        <button
          type="button"
          class="btn btn-primary"
          (click)="deleteDistrict()"
          data-bs-dismiss="modal"
        >
          {{ "COMMON.DELETE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #filterTemplate>
  <div class="filters-wrapper">
    <div class="search-bar">
      <img
        src="assets/icons/search.svg"
        alt="Search icon"
        class="search-icon"
      />
      <input
        type="text"
        class="search-input"
        [placeholder]="'COMMON.SEARCH' | translate"
        [(ngModel)]="searchValue"
        (keyup.enter)="onSearch()"
        (input)="onSearchChange()"
      />
    </div>
  </div>
</ng-template>
